export default {
  hotkey: '快捷键说明',
  delpoint: '删除点',
  cancelpoint: '撤销上一次打点',
  finish: '完成',
  submit: '提交',
  tool: '工具',
  alt: '按住alt，进入移动图片模式，松开后切换为原有模式',
  shift: '按住shift，进入预览模式，松开后切换为原有模式',
  ctrl: '在矩形模式下，可以对矩形进行选中和调整大小（编辑模式下将鼠标移动到矩形顶点，当鼠标指针变化后，就可以对矩形进行大小调整了，为了方便操作，可以将标注点大小调整为最大），松开后进入绘制矩形模式',
  zoom: '滑动鼠标滚轮会以鼠标所指坐标为中心，放大缩小图片',
  rightclick: '鼠标右键，会以鼠标所指坐标为中心，顺时针旋转图片',
  currtag: '当前标签',
  do: '操作',
  task: '任务',
  valid: '请完成检验',
  tagmax: '标注项个数超过最大值',
  tagmin: '标注项个数小于最小值',
  validinfo1: '存在未完成点集',
  validinfo2: '请先完成',
  validinfo3: '存在未完成多边形或折线',
  validinfo4: '存在未完成曲线',
  validinfo5: '全局题目未完成',
  validinfo6: '第',
  validinfo7: '个标注题目未完成',
  validinfo8: '不能在移动模式下完成,请切换回相应模式',
  validinfo9: '点数超过',
  validinfo10: '点数少于',
  validinfo11: '删除后点数少于',
  validinfo12: '页未标注',
  determine: '确定',
  cancel: '取消操作',
  error: '失败',
  pcd01: '辅助图片',
  pcd02: '重置位置',
  pcd03: '取前一帧',
  pcd04: '三视图',
  pcd05: '放大点',
  pcd06: '缩小点',
  pcd07: '覆盖',
  pcd08: '添加点',
  pcd09: '修改选中',
  dicom: '观察',
  normal01: '预设项',
  group01: '标注图',
  group02: '标注子图',
  semantic01: '颜色标注',
  delete: '删除成功',
  tips01: '此操作将删除所有标注项，是否继续执行？',
  tips02: '删除操作，将删除该项在所有帧中的标注！！',
  tips03: '存在未标记区域:',
  tips04: 'warning: 不同于选中类型的标注项,转为新建标注项',
  tips05: 'warning: 已存在curlist为',
  tips06: '的标注项,转为新建标注项',
  head01: '泛函标注工具',
  head02: '按下并拖动鼠标，拉出矩形框区域',
  head03: '单击鼠标进行打点，全部点打好后，点击',
  head04: '选择线段的起点单击鼠标，选择线段的终点单击鼠标，点击',
  head05: '单击鼠标，系统按点击顺序将点连成曲线',
  head06: '单击鼠标进行打点',
  head07: '需要与多边形或折线配合使用，使用此工具可连续打点',
  head08: '完成一次图形的绘制',
  head09: '提交任务',
  head10: '退出',
  head11: '中途离开'
}



// WEBPACK FOOTER //
// ./src/lang/zh/imgtemplate.js